import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    faFacebook, faXTwitter, faLinkedin, faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    VKShareButton,
    LinkedinShareButton,
} from 'react-share';
import exact from 'prop-types-exact';
import { LinkSimple } from '@phosphor-icons/react';
import MobileShare from '../mobileShare/MobileShare';

// DOCUMENTATION
// GitHub repo: https://github.com/nygardk/react-share

// OBS: This component requires an URL to work
// 1 - START - just call the sharing component sending a complete and valid URL as parameter to start use. EXAMPLE : <Sharing url="http://www.suaurl.com"/>
//              OR - pass only the path you wish to include on the the base url like  <Sharing path="/noticias"/>
// 2 - DEFAULT PROPS  - For default , if you didn't specify what is the share button to show, the component you show FACEBOOK SHARE
// or you can specify by the name - EXAMPLE:  <Sharing url="suaurl.com" shareButtonsTo={["facebook", "twitter"]} />
// 3 - you can choose the container direction and the button Content direction  using the props  directionContainer: 'horizontal',  directionButtonContent: 'vertical'.
// 4 - you can choose the 'iconSize' sending a number desired , but to have a better layout pass 'widthBlockIcon' too.
// 5 - NOTICE - Today the Sharing componet just work with FACEBOOK , VK, WHATSAPP and TWITTER, but uses only FACEBOOK, TWITTER AND WHATSAPP because it's the actual antena1 necessity
// but can  be update to work with others share button , see de list below.
// Linkedin, OK, Telegram, Reddit, Tumblr, Mailru, Email, Livejournal

// CONFIGS - YOU CANS PASS SPECIFY PROPERTIES
// FACEBOOK : Available properties: 'quote' and 'hashtag'  ---- ex: facebook={quote: "Meu nome da quote", hashtag: "#teste"}
// TWITTER :  Available properties: 'title', 'via' and 'hashtags'---- ex: twitter={title: "meuTitle", via:"aqui eh a via", hashtags : ["umaAqui", "duasAqui"]}
// WHATSAPP : Available properties: 'title' ---- ex: whatsapp={title: 'Title para o whatsapp'}
// VK : Available properties: 'title', 'description' and 'image' --- ex: vk={title: 'Title para o vk', description: 'description aqui pae', image: 'https://tudoradio.com/img/uploads/radios/radio_alphafm1017.png'}
const Sharing = ({
    path = '/',
    directionContainer = 'horizontal',
    directionButtonContent = 'vertical',
    url,
    shareButtonsTo = ['facebook'],
    iconSize = 32,
    widthBlockIcon = 55,
    facebook = {},
    twitter = {},
    whatsapp = {},
    vk = {},
    linkedin = {},
    styleEffect,
}) => {
    const [showShareMobile, setShowShareMobile] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        if (navigator.share) {
            setShowShareMobile(true);
        }
    }, []);

    // url: needs to be the complete (and valid) url
    // Use serverHost for both server and client until after hydration to avoid #418.
    const serverHost = process.env.BASE_APP_URL || 'https://www.antena1.com.br';
    const host = isMounted ? `${window.location.protocol}//${window.location.hostname}` : serverHost;
    let adjustedPath = path;

    if (adjustedPath.charAt(0) !== '/') {
        adjustedPath = `/${path}`;
    }

    // if url is given, use it, else mount the current page url with path prop
    const shareUrl = url || host + adjustedPath;

    const singleShareDirection = directionButtonContent === 'vertical' ? 'flex-column' : '';

    // DEFINE STYLE TO ICONS
    const styleToIcons = { fontSize: `${iconSize}px`, width: `${widthBlockIcon}px`, height: `${widthBlockIcon}px`, overflow: 'visible', alignItems: 'center' };

    return (
        <div className={`tw-flex tw-mt-0 tw-items-center tw-gap-3 ${directionContainer === 'vertical' ? 'flex-column' : ''}`}>
            {
                shareButtonsTo.includes('facebook') &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-flex tw-items-center`}>
                    <FacebookShareButton
                        hashtag={facebook?.hashtag}
                        quote={facebook?.quote}
                        url={shareUrl}
                    >
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <FontAwesomeIcon icon={faFacebook} />
                        </div>
                    </FacebookShareButton>
                </div>
            }
            {
                shareButtonsTo.includes('twitter') &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-flex tw-items-center`}>
                    <TwitterShareButton
                        title={twitter?.title}
                        via={twitter?.via}
                        hashtags={twitter?.hashtags || []}
                        url={shareUrl}
                    >
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <FontAwesomeIcon icon={faXTwitter} />
                        </div>
                    </TwitterShareButton>
                </div>
            }
            {
                shareButtonsTo.includes('whatsapp') &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-flex tw-items-center`}>
                    <WhatsappShareButton
                        title={whatsapp?.title}
                        url={shareUrl}
                    >
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </div>
                    </WhatsappShareButton>
                </div>
            }

            {
                shareButtonsTo.includes('linkedin') &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-flex tw-items-center`}>
                    <LinkedinShareButton title={linkedin?.title} url={shareUrl}>
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </div>
                    </LinkedinShareButton>
                </div>
            }
            {
                shareButtonsTo.includes('vk') &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-items-center tw-flex`}>
                    <VKShareButton
                        title={vk?.title}
                        url={shareUrl}
                    >
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <LinkSimple size={16} />
                        </div>
                    </VKShareButton>
                </div>
            }
            {
                showShareMobile &&
                <div className={`singleShare ${singleShareDirection} tw-group tw-flex tw-items-center`}>
                    <MobileShare
                        styleEffect={styleEffect}
                        location={shareUrl}
                        text={twitter?.title || 'Ouvi falar na Antena 1'}
                        styleBtn={{ ...styleToIcons, fontSize: `${iconSize * 0.8}px` }}
                    />

                </div>
            }

        </div>
    );
};

Sharing.propTypes = exact({
    path: PropTypes.string,
    directionContainer: PropTypes.string,
    directionButtonContent: PropTypes.string,
    styleEffect: PropTypes.string,
    url: PropTypes.string,
    shareButtonsTo: PropTypes.arrayOf(PropTypes.string),
    iconSize: PropTypes.number,
    widthBlockIcon: PropTypes.number,
    facebook: PropTypes.object,
    twitter: PropTypes.object,
    whatsapp: PropTypes.object,
    vk: PropTypes.object,
    linkedin: PropTypes.object,
});

export default Sharing;
